export default function FormLabel({ title, className }: { title: string; className?: string }) {
	return (
		<label className={`text-[#1D243C] font-semibold text-[14px] leading-[18px] ${className}`}>
			{title}
		</label>
	);
}
